import callApi from '../../util/apiCaller';
// Export Constants
import { reduce }  from 'lodash';

export const GOD_TABLE_SAVE_TABLE_STATES = 'GOD_TABLE_SAVE_TABLE_STATES';
export const GOD_TABLE_RESET_TABLE_STATES = 'GOD_TABLE_RESET_TABLE_STATES';
export const GOD_TABLE_LOAD_CUSTOM_META_DATA = 'GOD_TABLE_LOAD_CUSTOM_META_DATA';
export const GOD_TABLE_CLEAR_CUSTOM_META_DATA = 'GOD_TABLE_CLEAR_CUSTOM_META_DATA';
export const GOD_TABLE_DELETE_CUSTOM_META_DATA = 'GOD_TABLE_DELETE_CUSTOM_META_DATA';
export const GOD_TABLE_UPDATE_CUSTOM_META_DATA = 'GOD_TABLE_UPDATE_CUSTOM_META_DATA';
export const GOD_TABLE_FETCH_COLUMN_DATA = 'GOD_TABLE_FETCH_COLUMN_DATA';
export const GOD_TABLE_REQUEST_DELETE_COLUMN = 'GOD_TABLE_REQUEST_DELETE_COLUMN';
export const GOD_TABLE_REQUEST_EDIT_COLUMN = 'GOD_TABLE_REQUEST_EDIT_COLUMN';
export const GOD_TABLE_REQUEST_RESET_COLUMNS = 'GOD_TABLE_REQUEST_RESET_COLUMNS';
export const GOD_TABLE_REQUEST_EDIT_CUSTOM_META = 'GOD_TABLE_REQUEST_EDIT_CUSTOM_META';

export function saveState(organizationId, authId, tableId, config) {
  return (dispatch) => {
    return new Promise((resolve) => {
      dispatch({
        type: GOD_TABLE_SAVE_TABLE_STATES, authId, organizationId, tableId, config,
      });
      resolve(config);
    });
  };
}
export function resetAllTableStates() {
  return (dispatch) => {
    dispatch({
      type: GOD_TABLE_RESET_TABLE_STATES,
    });
    return Promise.resolve();
  };
}

export function saveCustomMetaData(metaId, objectId, value, columnId) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      // over promise
      dispatch({
        type: GOD_TABLE_UPDATE_CUSTOM_META_DATA, meta: { meta__id: metaId, object_id: objectId, value }, columnId,
      });
      callApi(`custom-meta-data/${metaId}/${objectId}`, 'POST', { value }).then(
        ({ meta }) => {
          dispatch({
            type: GOD_TABLE_UPDATE_CUSTOM_META_DATA, meta, columnId,
          });
          resolve(meta);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function deleteCustomMetaData(metaId, objectId, columnId) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      callApi(`custom-meta-data/${metaId}/${objectId}`, 'DELETE').then(
        (results) => {
          dispatch({
            type: GOD_TABLE_DELETE_CUSTOM_META_DATA, metaId, objectId, columnId,
          });
          resolve(results);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}

export function loadCustomMetaData(metaId) {
  return (dispatch) => {
    dispatch({
      type: GOD_TABLE_LOAD_CUSTOM_META_DATA, metaId, status: 'loading', errors: null, data: {},
    });
    const p = new Promise((resolve, reject) => {
      callApi(`custom-meta-data/${metaId}`, 'GET').then(
        (results) => {
          dispatch({
            type: GOD_TABLE_LOAD_CUSTOM_META_DATA,
            metaId,
            status: 'loaded',
            errors: null,
            data: results.metas,
          });
          resolve(results.metas);
        },
        (errors) => {
          dispatch({
            type: GOD_TABLE_LOAD_CUSTOM_META_DATA,
            metaId,
            status: 'errors',
            errors,
            data: {},
          });
          reject(errors);
        },
      );
    });
    return p;
  };
}


export function dispatchColumnData(data, loading = false) {
  return (dispatch) => {
    return dispatch({
      type: GOD_TABLE_FETCH_COLUMN_DATA, 
      data: reduce(data, (items, datum, k) => {
        items[k] = {
          ...datum,
          $loading: loading,
        }
        return items;
      }, {}),
    });
  };
}

export function fetchColumnsData(colIds, ids, resourceType, byPassSocket = false) {
  return (dispatch) => {
    const p = new Promise((resolve, reject) => {
      const params = {
        ids,
      };
      dispatchColumnData(reduce(ids, (items, id) => {
        items[id] = {};
        return items;
      }, {}), true)(dispatch);

      callApi(`table-preferences/column-data/?ids=${colIds.join(',')}&resourceType=${resourceType}${byPassSocket ? '&byPassSocket=true' : ''}`, 'POST', params).then(
        (data) => {
          if (!data.socketId) {
            dispatchColumnData(data)(dispatch);
          } 
          resolve(data);
        },
        (errors) => {
          reject(errors);
        },
      );
    });
    return p;
  };
}


export function requestDeleteColumn(tableId, column) {
  return (dispatch) => {
    dispatch({
      type: GOD_TABLE_REQUEST_DELETE_COLUMN, tableId, column,
    });
    return Promise.resolve();
  };
}

export function requestEditColumn(tableId, column) {
  return (dispatch) => {
    dispatch({
      type: GOD_TABLE_REQUEST_EDIT_COLUMN, tableId, column: { ...column },
    });
    return Promise.resolve();
  };
}

export function requestResetColumns(tableId) {
  return (dispatch) => {
    dispatch({
      type: GOD_TABLE_REQUEST_RESET_COLUMNS, tableId,
    });
    return Promise.resolve();
  };
}

export function requestEditCustomMeta(meta) {
  return (dispatch) => {
    dispatch({
      type: GOD_TABLE_REQUEST_EDIT_CUSTOM_META, meta,
    });
    return Promise.resolve();
  };
}
